<template>
  <div>
    <div>Welcome</div>
    <div>-------------</div>

    <div>
      <input type="text" v-model="a" /> + <input type="text" v-model="b" /> =
      <input type="text" v-model="c" />
    </div>
    <div>
      <span>{{ a }}</span> + <span>{{ b }}</span> = <span>{{ c }}</span>
    </div>
  </div>
</template>
<script>
export default {
  name: "littleAdd",
  data() {
    return {
      a: 0,
      b: 0,
      c: 0
    };
  },
  watch: {
    a(val) {
      if (val) {
        this.c = this.a * 1 + this.b * 1;
      }
    },
    b(val) {
      if (val) {
        this.c = this.a * 1 + this.b * 1;
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/my-plugins/littleAdd.vue